import { useMemo } from 'react';
import { useTranslation } from '@frontend/i18n';
import { useMultiOnboardingDashboardConfig } from '@frontend/onboarding-dashboard';
import { useScopedAppFlagStore } from '@frontend/scope';
import { createNavItem, createSubNavItems } from '../nav-item-utils';
import { featureDefinition as homeFeatureDefinition } from './feature-definitions';

export const useHomeNavItem = () => {
  const { t } = useTranslation('primaryNav');
  const { showOnboardingDashboard } = useMultiOnboardingDashboardConfig();
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const ourPartnersPage = getFeatureFlagValue('our-partners-page');
  const homeItems = homeFeatureDefinition.items;

  const subNavItems = useMemo(
    () =>
      createSubNavItems([
        {
          label: t('Welcome to Weave'),
          relativePath: '/onboarding',
          trackingId: 'app-nav-item-onboarding-dashboard',
          show: showOnboardingDashboard,
          description: undefined,
        },
        {
          ...homeItems['/dashboard'],
          label: t('My Dashboard'),
          relativePath: '/dashboard',
        },
        {
          label: t('Settings'),
          path: '#settings/organization' as any,
          trackingId: 'app-nav-item-portal',
          show: true,
          description: undefined,
        },
        {
          ...homeItems['/partners'],
          label: t('Our Partners'),
          relativePath: '/partners',
          show: ourPartnersPage,
        },
      ]),
    [t, showOnboardingDashboard, ourPartnersPage, homeItems]
  );

  return useMemo(
    () =>
      createNavItem('home', {
        iconName: 'home',
        label: t('Home'),
        root: '/home',
        subNavItems,
        show: true,
      }),
    [t, subNavItems]
  );
};
